import React from "react";
import {TransactionStatus, TransactionType} from "../../common/Constants";
import {Badge} from "reactstrap";

const TransactionTypes = [
    {
        text: "Cash",
        value: TransactionType.Cash
    },
    {
        text: "Cheque Deposit",
        value: TransactionType.Cheque
    },
    {
        text: "Mobile Money",
        value: TransactionType.MobileMoney
    },
    {
        text: "Card ( Visa, Mastercard )",
        value: TransactionType.Card
    },
    {
        text: "Yolim",
        value: TransactionType.Yolim
    },
    /*{
        text: "Yolim",
        value: TransactionType.VirtualCredit
    }*/
];

export const formatTransactionType = (txn) => {

    if(txn.type & TransactionType.Charge){
        return "Receive Payment";
    }
    else if(txn.type & TransactionType.Refund){
        return "Refund Payment";
    }

    return "Unknown";
};

export const formatPaymentMethod = (txn) => {

    if(txn.type & TransactionType.Cash){
        return "Cash";
    }
    else if(txn.type & TransactionType.Cheque){
        return "Cheque";
    }
    else if(txn.type & TransactionType.MobileMoney){
        return "Mobile";
    }
    else if(txn.type & TransactionType.Card){
        return "Card";
    }
    else if(txn.type & TransactionType.BankAccount){
        return "Bank";
    }
    /*else if(txn.type & TransactionType.VirtualCredit){
        return "Yolim";
    }*/
    else if(txn.type & TransactionType.Yolim){
        return "Yolim";
    }

    return "Unknown"
};

export const formatTransactionPaymentStatus = (txn) => {

    let status;
    switch (txn.status){
        case TransactionStatus.Failed:
            status = <Badge pill={true} color={"danger"}>Transaction Failed</Badge>;
            break;
        case TransactionStatus.Invalid:
            status = <Badge pill={true} color={"warning"}>Invalid</Badge>;
            break;
        case TransactionStatus.Succeeded:
            status = <Badge color={"success"} pill={true}>Successful</Badge>;
            break;
        case TransactionStatus.Idle:

            if(txn.type & TransactionType.Charge)
                status = "Payment Initiated";
            else if(txn.type & TransactionType.Refund)
                status = "Refund Initiated";

            status = <Badge pill={true} color={"secondary"}>{status}</Badge>;

            break;
    }

    return status || "Unknown";

};



// WEBPACK FOOTER //
// ./src/views/Transactions/TransactionHelpers.js